import { defineMessages } from 'react-intl';

/** The copy of the cover field in every place a cover can change (design cover-editor a1 to a4). */
export const coverEntryMessages = defineMessages({
  design: { id: 'app.sml.coverEditor.entry.design', defaultMessage: 'Design a cover' },
  designNew: { id: 'app.sml.coverEditor.entry.designNew', defaultMessage: 'Design a new cover' },
  edit: { id: 'app.sml.coverEditor.entry.edit', defaultMessage: 'Edit cover' },
  upload: { id: 'app.sml.coverEditor.entry.upload', defaultMessage: 'Upload a file' },
  replace: { id: 'app.sml.coverEditor.entry.replace', defaultMessage: 'Replace with a file' },
  hintNone: {
    id: 'app.sml.coverEditor.entry.hint.none',
    defaultMessage: 'We make a first version for you. Then change anything.',
  },
  hintEditor: { id: 'app.sml.coverEditor.entry.hint.editor', defaultMessage: 'Made in the cover editor' },
  hintFile: {
    id: 'app.sml.coverEditor.entry.hint.file',
    defaultMessage: 'Start from this cover in the editor, or from a new picture.',
  },
  hintReleased: {
    id: 'app.sml.coverEditor.entry.hint.released',
    defaultMessage: 'The stores keep their own cover until your distributor gets the new file.',
  },
  saveFirst: {
    id: 'app.sml.coverEditor.entry.saveFirst',
    defaultMessage: 'Save the song first. Then design its cover.',
  },
  // Add a release (a3)
  saveAndDesign: { id: 'app.sml.coverEditor.entry.saveAndDesign', defaultMessage: 'Save and design the cover' },
  saveAndDesignHint: {
    id: 'app.sml.coverEditor.entry.saveAndDesignHint',
    defaultMessage: 'No cover yet? Save the release. Then MUSIC24 opens the cover editor with a first version ready.',
  },
  // The wizards (a4)
  wizardNone: { id: 'app.sml.coverEditor.entry.wizard.none', defaultMessage: 'This song has no cover yet.' },
  wizardNoneHint: {
    id: 'app.sml.coverEditor.entry.wizard.noneHint',
    defaultMessage: 'A page with a cover gets more saves. It takes a minute.',
  },
  wizardFromSong: {
    id: 'app.sml.coverEditor.entry.wizard.fromSong',
    defaultMessage: 'From the song. A change shows on every page of the song.',
  },
  newTab: { id: 'app.sml.coverEditor.entry.newTab', defaultMessage: 'Opens in a new tab' },
});
